import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../internal/Action.js";
import { QualifierValue } from "../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../internal/qualifier/Qualifier.js";
import { prepareColor } from "../internal/utils/prepareColor.js";
/**
 * @description Adds a solid border around an image or video.
 *
 *  <b>Learn more:</b>
 * {@link https://cloudinary.com/documentation/image_transformations#adding_image_borders|Adding image borders}
 * @memberOf Actions
 * @namespace Border
 * @example
 * import {Cloudinary} from "@cloudinary/url-gen";
 * import {solid} from "@cloudinary/url-gen/actions/border";
 *
 * const yourCldInstance = new Cloudinary({cloud:{cloudName:'demo'}});
 * const image = yourCldInstance.image('woman');
 * image.border(
 *  solid(15, 'green'),
 *  // Or alternatively
 *  solid().width(15).color('green')
 * );
 *
 */

/**
 * @memberOf Actions.Border
 * @see Actions.Border
 * @example
 * // Used through a builder function Border.solid(), and not by creating a new instance
 * import {Cloudinary} from "@cloudinary/url-gen";
 *
 * const yourCldInstance = new Cloudinary({cloud:{cloudName:'demo'}});
 * const image = yourCldInstance.image('woman');
 * image.border(
 *  Border.solid(15, 'green'),
 *  // Or alternatively
 *  Border.solid().width(15).color('green')
 * );
 */

var BorderAction = /*#__PURE__*/function (_Action) {
  _inherits(BorderAction, _Action);

  var _super = _createSuper(BorderAction);

  /**
   * @description Adds a border of the specified type around an image or video.
   * @param {'solid'} borderType The type of border (currently only 'solid' is supported). Use values in {@link Qualifiers.Border|Border Values}.
   * @param {string} color The color of the border.
   * @param {number} borderWidth The width in pixels.
   */
  function BorderAction(borderType, color, borderWidth) {
    var _this;

    _classCallCheck(this, BorderAction);

    _this = _super.call(this);
    _this.borderType = borderType;
    _this.borderColor = prepareColor(color);
    _this.borderWidth = borderWidth;
    return _this;
  }
  /**
   * @description Sets the width of the border
   * @param {number | string} borderWidth The width in pixels.
   */


  _createClass(BorderAction, [{
    key: "width",
    value: function width(borderWidth) {
      this.borderWidth = borderWidth;
      return this;
    }
    /**
     * @description Sets the color of the border.
     * @param {string} borderColor The color of the border.
     */

  }, {
    key: "color",
    value: function color(borderColor) {
      this.borderColor = prepareColor(borderColor);
      return this;
    }
    /**
     * @description Rounds the specified corners of an image.
     * @param {RoundCornersAction} roundCorners
     * @return {this}
     */

  }, {
    key: "roundCorners",
    value: function roundCorners(_roundCorners) {
      this._roundCorners = _roundCorners;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var qualifierValue = new QualifierValue(["".concat(this.borderWidth, "px"), this.borderType, "".concat(this.borderColor)]).setDelimiter('_');
      this.addQualifier(new Qualifier('bo', qualifierValue));

      if (this._roundCorners) {
        this.addQualifier(this._roundCorners.qualifiers.get('r'));
      }
    }
  }]);

  return BorderAction;
}(Action);
/**
 * @summary action
 * @memberOf Actions.Border
 * @description Sets the style of the border.
 * @param {number | string} width The width in pixels.
 * @param {string} color The color of the border, e.g 'green', 'yellow'.
 * @return {Actions.Border.BorderAction}
 */


function solid(width, color) {
  return new BorderAction('solid', color, width);
}

var Border = {
  solid: solid
};
export { BorderAction, Border, solid };